var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigmaHomeDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/left-sidebar/ic home"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6",
    x: 11,
    y: 1,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7",
    x: 1,
    y: 11,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#2894FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5",
    x: 11,
    y: 11,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#2894FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaHomeDefault);
export default __webpack_public_path__ + "static/media/figma-home-default.bd9c16ce3d2d020fb3bfdf8e63db8f61.svg";
export { ForwardRef as ReactComponent };